/*
 * pawpaw-anchor-scroll.js
 *
 * Two Horizon behaviours combine to break every in-page #offer CTA:
 *
 * 1. html and body are `overflow: hidden` and the real scroll container is
 *    div.page-wrapper. Chrome does not fragment-navigate a non-root scroller, so
 *    <a href="#offer"> updates location.hash and scrolls nothing. Measured on the
 *    live product page 3 Aug 2026: scrollTop identical before and after the click.
 *
 * 2. .page-wrapper has CSS `scroll-behavior: smooth`. A scrollTo() with behavior
 *    'smooth' OR 'auto' (auto defers to the CSS value) is abandoned partway when the
 *    travel distance is large and sections in between are still being laid out --
 *    from the page-bottom CTA it moved 0px. Only behavior 'instant', which overrides
 *    the CSS, lands reliably. Do not "improve" this to smooth.
 *
 * Scoped to #offer on purpose: a blanket a[href^="#"] handler would preventDefault
 * on theme components that use hash hrefs as toggles.
 */
(function () {
  var TARGET = '#offer';
  var FALLBACK_OFFSET = 90;

  function jump() {
    var el = document.querySelector(TARGET);
    var box = document.querySelector('.page-wrapper');
    if (!el || !box) return false;

    var offset = parseFloat(getComputedStyle(el).scrollMarginTop);
    if (!offset || isNaN(offset)) offset = FALLBACK_OFFSET;

    var destination = el.getBoundingClientRect().top + box.scrollTop - offset;
    if (isNaN(destination)) return false;

    box.scrollTo({ top: Math.max(0, destination), behavior: 'instant' });
    return true;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('a[href="' + TARGET + '"]') : null;
    if (!link) return;

    if (jump()) {
      event.preventDefault();
      if (history.replaceState) history.replaceState(null, '', TARGET);
    }
  });

  // Landing directly on /#offer from an ad or an email hits the same bug.
  window.addEventListener('load', function () {
    if (window.location.hash === TARGET) {
      window.setTimeout(jump, 150);
    }
  });
})();
